import Axios from "../../axios";
import { ApiResponse } from "../../apiResponse";

// @param candidateData: object
// example:
// {
//   "full_name": "Balqees qasem"
// }
export function updateLiaison(liaisonData: object): Promise<ApiResponse> {
  return Axios.put("v1/liaisons/liaisons", liaisonData);
}
